/* Warmhold theme script. Keeps the site's motion and layout, uses Shopify's real cart. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function assetUrl(src) {
    if (!src || /^(https?:)?\/\//.test(src)) return src;
    var base = window.ASSET_BASE || '';
    return base ? base + src.replace(/^.*\//, '') : src;
  }
  function money(cents) { var v = (cents / 100); return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
  var toastTimer;
  function toast(msg) { var t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('is-on'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600); }

  /* nav */
  (function () {
    var nav = $('.nav'), toggle = $('.nav__toggle');
    if (toggle) toggle.addEventListener('click', function () { var open = nav.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', open); });
    $$('.has-menu > button').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); var li = b.parentElement, open = li.getAttribute('data-open') === 'true'; li.setAttribute('data-open', !open); b.setAttribute('aria-expanded', !open); });
    });
    document.addEventListener('click', function (e) { $$('.has-menu[data-open="true"]').forEach(function (li) { if (!li.contains(e.target)) { li.setAttribute('data-open', 'false'); $('button', li).setAttribute('aria-expanded', 'false'); } }); });
    $$('[data-year]').forEach(function (el) { el.textContent = new Date().getFullYear(); });
  })();

  /* cart drawer backed by Shopify */
  var cart = {
    open: function () { var c = $('#cart'); if (!c) return; c.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; },
    close: function () { var c = $('#cart'); if (!c) return; c.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; },
    refresh: function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(this.render.bind(this)); },
    render: function (data) {
      if (!data || !data.items) return data;
      $$('.cart-count').forEach(function (el) { el.textContent = data.item_count; el.setAttribute('data-zero', data.item_count === 0); });
      var box = $('[data-cart-items]');
      if (box) {
        if (!data.items.length) box.innerHTML = '<div class="cart__empty"><p>Your cart is empty.</p><a class="btn btn--ghost btn--sm" href="/#shop">Shop heated gear</a></div>';
        else box.innerHTML = data.items.map(function (i) {
          var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '';
          var variant = (i.variant_title && i.variant_title !== 'Default Title') ? ' · ' + esc(i.variant_title) : '';
          return '<div class="cart-item"><img src="'+img+(img.indexOf('?')>-1?'&':'?')+'width=144" alt="" width="72" height="72"><div><h4>' + esc(i.product_title) + '</h4><p>' + esc(i.product_type || '') + variant + '</p>' +
            '<div class="cart-item__qty"><button type="button" data-qty="-1" data-key="' + i.key + '" aria-label="Decrease quantity">−</button><span>' + i.quantity + '</span><button type="button" data-qty="1" data-key="' + i.key + '" aria-label="Increase quantity">+</button></div></div>' +
            '<div><div class="cart-item__price">' + money(i.line_price) + '</div><button type="button" class="cart-item__remove" data-remove="' + i.key + '">Remove</button></div></div>';
        }).join('');
      }
      var tot = $('[data-cart-total]'); if (tot) tot.textContent = money(data.total_price);
      return data;
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(cart.render.bind(cart));
    },
    add: function (items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); return r.json(); })
        .then(function () { return cart.refresh(); });
    }
  };
  window.WHCart = cart;
  cart.refresh();
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart],[data-close-cart],[data-qty],[data-remove],[data-checkout]');
    if (!t || t.closest('[data-product-form]')) return;
    if (t.hasAttribute('data-open-cart')) cart.open();
    else if (t.hasAttribute('data-close-cart')) cart.close();
    else if (t.hasAttribute('data-qty')) { var line = t.closest('.cart-item'); if (!line || !t.hasAttribute('data-key')) return; var n = parseInt($('span', $('.cart-item__qty', line)).textContent, 10) + parseInt(t.getAttribute('data-qty'), 10); cart.change(t.getAttribute('data-key'), Math.max(0, n)); }
    else if (t.hasAttribute('data-remove')) cart.change(t.getAttribute('data-remove'), 0);
    else if (t.hasAttribute('data-checkout')) { t.setAttribute('aria-busy', 'true'); location.href = '/checkout'; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cart.close(); closeLightbox(); } });

  /* product page */
  (function () {
    var form = $('[data-product-form]'); if (!form) return;
    var variantInput = $('[data-variant-input]', form), qtyInput = $('[data-qty-input]', form);
    var state = { variant: variantInput.value, qty: 1, also: null, price: 0 };
    var firstPack = $('.pack', form); if (firstPack) state.price = 0;
    function paint() {
      $$('.swatch', form).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-variant') === state.variant); });
      $$('.pack', form).forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-qty') === String(state.qty) && (b.getAttribute('data-add-also') || null) === state.also)); });
      var label = $('[data-variant-label]', form);
      var chosen = $('.swatch[aria-checked="true"]', form);
      if (label && chosen) label.textContent = chosen.textContent.trim();
      var unit = chosen ? parseInt(chosen.getAttribute('data-variant-price'), 10) : null;
      var packEl = $('.pack[aria-checked="true"]', form);
      var total = '';
      if (packEl) { var amt = packEl.querySelector('[data-pack-amount]'); total = (amt || packEl.querySelector('.pack__price')).textContent.trim(); }
      $$('[data-price]').forEach(function (el) { el.textContent = total; });
      variantInput.value = state.variant; qtyInput.value = state.qty;
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('.swatch, .pack'); if (!b) return;
      if (b.classList.contains('swatch')) { state.variant = b.getAttribute('data-variant'); var img = b.getAttribute('data-image'); }
      else { state.qty = parseInt(b.getAttribute('data-qty'), 10) || 1; state.also = b.getAttribute('data-add-also') || null; }
      paint();
    });
    paint();
    function submit(btn, goCheckout) {
      btn.setAttribute('aria-busy', 'true');
      var items = [{ id: parseInt(state.variant, 10), quantity: state.qty }];
      if (state.also) items.push({ id: parseInt(state.also, 10), quantity: 1 });
      cart.add(items).then(function () {
        btn.removeAttribute('aria-busy');
        if (goCheckout) location.href = '/checkout';
        else { cart.open(); toast('Added to your cart'); }
      }).catch(function (err) { btn.removeAttribute('aria-busy'); toast(err.message); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit($('[data-add]:not([data-buy-now])', form), false); });
    $$('[data-buy-now]').forEach(function (b) { b.addEventListener('click', function () { submit(b, true); }); });
    $$('.sticky-bar [data-add]').forEach(function (b) { b.addEventListener('click', function () { submit(b, false); }); });

    /* gallery */
    var mainImg = $('[data-gallery-main]'), thumbs = $$('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = assetUrl(t.getAttribute('data-thumb'));
        if (!mainImg || mainImg.getAttribute('src') === src) return;
        mainImg.classList.add('is-fading');
        setTimeout(function () { mainImg.src = src; mainImg.onload = function () { mainImg.classList.remove('is-fading'); }; }, 160);
        thumbs.forEach(function (x) { x.setAttribute('aria-current', assetUrl(x.getAttribute('data-thumb')) === src); });
      });
    });

    /* sticky bar appears once the buy button scrolls away */
    var bar = $('.sticky-bar'), anchor = $('[data-buy-anchor]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky');
      new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(anchor);
    }
  })();

  /* reviews */
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6L3.3 9.8l6.1-.7z"/></svg>';
  function stars(n) { var out = '<span class="stars" aria-label="' + n + ' out of 5 stars">'; for (var i = 1; i <= 5; i++) out += STAR.replace('<svg', i <= Math.round(n) ? '<svg' : '<svg class="off"'); return out + '</span>'; }
  var lightbox;
  function closeLightbox() { if (lightbox) lightbox.setAttribute('data-open', 'false'); }
  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement('div'); lightbox.className = 'lightbox';
      lightbox.innerHTML = '<button type="button" class="icon-btn" aria-label="Close photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button><img alt="">';
      document.body.appendChild(lightbox);
      lightbox.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG') closeLightbox(); });
    }
    var img = $('img', lightbox); img.src = src; img.alt = alt || 'Customer photo'; lightbox.setAttribute('data-open', 'true');
  }
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-photo]'); if (b) openLightbox(b.getAttribute('data-photo'), b.getAttribute('aria-label')); });
  function reviewCard(r) {
    var photos = (r.images || []).map(function (raw) { var src = assetUrl(raw); return '<button type="button" data-photo="' + src + '" aria-label="Photo from ' + esc(r.name) + '"><img src="'+src+'?width=80" srcset="'+src+'?width=80 1x, '+src+'?width=160 2x" alt="Customer photo" loading="lazy" width="74" height="74"></button>'; }).join('');
    return '<article class="review' + (r.pending ? ' review--pending' : '') + '">' +
      '<div class="review__top">' + stars(r.rating) + (r.pending ? '<span class="review__badge" style="color:var(--muted)">Pending review</span>' : '<span class="review__badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Verified buyer</span>') + '</div>' +
      (r.title ? '<h3>' + esc(r.title) + '</h3>' : '') + '<p>' + esc(r.text) + '</p>' +
      (r.update ? '<p class="review__update"><strong>Update:</strong> ' + esc(r.update) + '</p>' : '') +
      (photos ? '<div class="review__photos">' + photos + '</div>' : '') +
      '<div class="review__meta"><span>' + (r.name === 'Verified buyer' ? '<strong>Buyer in ' + esc(r.country) + '</strong>' : '<strong>' + esc(r.name) + '</strong>' + (r.country ? ', ' + esc(r.country) : '')) + (r.variant ? ' · ' + esc(r.variant) : '') + '</span><span>' + esc(r.date) + '</span></div></article>';
  }
  (function () {
    if (!window.REVIEWS) return;
    var pending = []; try { pending = JSON.parse(localStorage.getItem('wh_pending_reviews') || '[]'); } catch (e) {}
    $$('[data-reviews]').forEach(function (box) {
      var which = box.getAttribute('data-reviews');
      var list = which === 'featured'
        ? window.REVIEWS.filter(function (r) { return r.images && r.images.length && r.rating >= 4; }).slice(0, 6)
        : window.REVIEWS.filter(function (r) { return r.product === which; }).concat(pending.filter(function (r) { return r.product === which; }));
      var step = parseInt(box.getAttribute('data-show') || '6', 10), shown = 0;
      function more() { var chunk = list.slice(shown, shown + step); box.insertAdjacentHTML('beforeend', chunk.map(reviewCard).join('')); shown += chunk.length; var mb = $('[data-reviews-more="' + which + '"]'); if (mb) mb.classList.toggle('hidden', shown >= list.length); }
      if (!list.length) box.innerHTML = '<div class="review-empty">No reviews on this page yet. Be the first to write one below.</div>'; else more();
      var mb = $('[data-reviews-more="' + which + '"]'); if (mb) mb.addEventListener('click', more);
    });
    var form = $('[data-review-form]'); if (!form) return;
    var rating = 0, starBtns = $$('.star-input button', form);
    starBtns.forEach(function (b, i) { b.innerHTML = STAR; b.addEventListener('click', function () { rating = i + 1; starBtns.forEach(function (x, j) { x.classList.toggle('on', j < rating); }); }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var ok = true;
      ['name', 'title', 'text'].forEach(function (n) { var f = form.elements[n], fld = f.closest('.field'); var bad = !f.value.trim(); fld.classList.toggle('is-invalid', bad); if (bad) ok = false; });
      if (!rating) { $('[data-error-rating]', form).closest('.field').classList.add('is-invalid'); ok = false; }
      if (!ok) return;
      var r = { product: form.getAttribute('data-review-form'), name: form.elements.name.value.trim(), title: form.elements.title.value.trim(), text: form.elements.text.value.trim(), rating: rating, date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }), pending: true };
      pending.push(r); try { localStorage.setItem('wh_pending_reviews', JSON.stringify(pending)); } catch (e) {}
      var box = $('[data-reviews="' + r.product + '"]'); if (box) { var empty = $('.review-empty', box); if (empty) empty.remove(); box.insertAdjacentHTML('afterbegin', reviewCard(r)); }
      form.reset(); rating = 0; starBtns.forEach(function (x) { x.classList.remove('on'); });
      $('.form-success', form).classList.add('is-on');
    });
  })();

  /* motion */
  function staticState() {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    $$('.warm-frame__glow').forEach(function (g) { g.classList.add('is-on'); });
    $$('[data-count]').forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
    $$('.temp').forEach(function (t) { t.classList.add('is-warm'); var v = $('.temp__val', t); if (v) v.textContent = v.getAttribute('data-to'); });
  }
  var countUp = function (el) { el.textContent = el.getAttribute('data-count'); };
  var revealPending = $$('.reveal'), countPending = $$('[data-count]');
  function revealCheck() {
    var vh = window.innerHeight || 800, batch = [];
    revealPending = revealPending.filter(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh * 0.92 && r.bottom > 0) { batch.push(el); return false; } return true; });
    batch.forEach(function (el, i) { setTimeout(function () { el.classList.add('is-in'); }, Math.min(i, 8) * 90); });
    countPending = countPending.filter(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh * 0.9 && r.bottom > 0) { countUp(el); return false; } return true; });
  }
  function motion() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { staticState(); return; }
    revealCheck();
    if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function () { revealCheck(); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }); revealPending.concat(countPending).forEach(function (el) { io.observe(el); }); }
    window.addEventListener('scroll', revealCheck, { passive: true });
    window.addEventListener('resize', revealCheck);
    if (!window.gsap || !window.ScrollTrigger) { staticState(); return; }
    gsap.registerPlugin(ScrollTrigger);
    countUp = function (el) { var to = +el.getAttribute('data-count'), o = { n: 0 }; gsap.to(o, { n: to, duration: 1.6, ease: 'power2.out', onUpdate: function () { el.textContent = Math.round(o.n); } }); };
    $$('.temp').forEach(function (t) {
      var v = $('.temp__val', t), from = +v.getAttribute('data-from') || 8, to = +v.getAttribute('data-to') || 60, o = { n: from };
      var glow = $('.warm-frame__glow', t.parentElement);
      setTimeout(function () { if (glow) glow.classList.add('is-on'); }, 300);
      gsap.to(o, { n: to, duration: 2.6, delay: .35, ease: 'power2.out', onUpdate: function () { v.textContent = Math.round(o.n); t.classList.toggle('is-warm', o.n > (from + to) / 2); } });
    });
    gsap.utils.toArray('.band__img img').forEach(function (img) {
      gsap.fromTo(img, { yPercent: -5, scale: 1.08 }, { yPercent: 5, scale: 1.08, ease: 'none', scrollTrigger: { trigger: img.closest('.band'), start: 'top bottom', end: 'bottom top', scrub: true } });
    });
  }
  if (document.readyState === 'complete') motion(); else window.addEventListener('load', motion);
})();
